document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('reveal-enabled');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  const isOpen = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!isOpen));
  nav?.toggleAttribute('data-open', !isOpen);
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const selected = event.target.options[event.target.selectedIndex];
  const price = document.querySelector('[data-product-price]');
  if (price && selected.dataset.price) price.textContent = selected.dataset.price;
});

document.addEventListener('click', (event) => {
  const filterButton = event.target.closest('[data-resource-filter]');
  if (!filterButton) return;

  const library = filterButton.closest('[data-resource-library]');
  const selectedCategory = filterButton.dataset.resourceFilter;
  library.querySelectorAll('[data-resource-filter]').forEach((button) => {
    const active = button === filterButton;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });

  library.querySelectorAll('[data-resource-card]').forEach((card) => {
    const show = selectedCategory === 'all' || card.dataset.category === selectedCategory;
    card.hidden = !show;
    if (show) card.classList.add('is-visible');
  });
});

const revealItems = document.querySelectorAll('[data-reveal]');
if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 });
  revealItems.forEach((item) => revealObserver.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'));
}
